import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const { user, loading, login } = useAuth();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-form">
          <h2>Conecte-se</h2>
          <p style={{ textAlign: 'center' }}>Verificando sessão...</p>
        </div>
      </div>
    );
  }

  if (user) {
    if (user.roles?.includes('admin')) {
      return <Navigate to="/admin" replace />;
    }

    if (user.roles?.includes('coach')) {
      return <Navigate to="/coach" replace />;
    }

    if (user.roles?.includes('participante')) {
      return <Navigate to="/participante" replace />;
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (enviando) return;

    setErro('');
    setEnviando(true);

    try {
      const usuario = await login(email, senha);

      if (usuario.roles?.includes('admin')) {
        navigate('/admin', { replace: true });
        return;
      }

      if (usuario.roles?.includes('coach')) {
        navigate('/coach', { replace: true });
        return;
      }

      if (usuario.roles?.includes('participante')) {
        navigate('/participante', { replace: true });
        return;
      }

      setErro('Seu usuário não possui um perfil de acesso válido.');
    } catch (e) {
      setErro(e.message || 'Não foi possível entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Conecte-se</h2>

        <label htmlFor="email">E-mail:</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />

        <label htmlFor="senha">Senha:</label>
        <input
          id="senha"
          type="password"
          autoComplete="current-password"
          value={senha}
          onChange={e => setSenha(e.target.value)}
          required
        />

        {erro && (
          <div
            role="alert"
            style={{
              marginBottom: '1rem',
              padding: '0.8rem',
              borderRadius: 6,
              background: '#fff1f0',
              color: '#9f1c16',
              fontWeight: 600
            }}
          >
            {erro}
          </div>
        )}

        <button type="submit" disabled={enviando}>
          {enviando ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
